var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    'border-top': ("1px solid " + _vm.lineColor),
    'margin-top': _vm.mtop,
    'margin-bottom': _vm.mbottom})})}
var staticRenderFns = []

export { render, staticRenderFns }